import { useState, useEffect, useRef } from "react";

/* ─────────────────────────────────────────
   DATA  – update here to change content
───────────────────────────────────────── */
const DATA = {
  name: "Soham Patne",
  role: "Full-Stack Developer",
  email: "sohampatne13@gmail.com",
  phone: "9021189939",
  location: "Panvel, Maharashtra",
  github: "https://github.com/sp1130?tab=projects",
  linkedin:
    "https://www.linkedin.com/in/soham-patne-b81247357?utm_source=share_via&utm_content=profile&utm_medium=member_android",
  resume: "/assets/Soham_Patne.pdf",
  profile:
    "Full-Stack Java Developer with a Bachelor's degree in Computer Science and currently pursuing MCA (AIML). Hands-on experience in building scalable web applications using Java, J2EE, Spring, Spring Boot, React, Tomcat, and MySQL. Skilled in designing RESTful APIs and developing responsive front-end interfaces.",

  skillCategories: [
    {
      title: "Backend Development",
      color: "#38bdf8",
      skills: [
        { name: "Java", icon: "☕" },
        { name: "J2EE", icon: "🏢" },
        { name: "Spring", icon: "🌿" },
        { name: "Spring Boot", icon: "🍃" },
        { name: "Hibernate", icon: "🗄️" },
        { name: "JDBC", icon: "🔌" },
        { name: "Servlets", icon: "⚙️" },
        { name: "Node.js", icon: "🟩" },
      ],
    },
    {
      title: "Frontend Development",
      color: "#f87171",
      skills: [
        { name: "HTML5", icon: "🌐" },
        { name: "CSS3", icon: "🎨" },
        { name: "JavaScript", icon: "🟨" },
        { name: "React", icon: "⚛️" },
        { name: "Tailwind CSS", icon: "💨" },
      ],
    },
    {
      title: "Frameworks & Libraries",
      color: "#c084fc",
      skills: [
        { name: "ReactJS", icon: "⚛️" },
        { name: "Bootstrap", icon: "🅱️" },
        { name: "FastAPI", icon: "⚡" },
        { name: "LangChain", icon: "🔗" },
      ],
    },
    {
      title: "Database",
      color: "#34d399",
      skills: [
        { name: "MySQL", icon: "🐬" },
        { name: "MongoDB", icon: "🍃" },
        { name: "ChromaDB", icon: "🧠" },
      ],
    },
    {
      title: "Programming Languages",
      color: "#fbbf24",
      skills: [
        { name: "Python", icon: "🐍" },
        { name: "Java", icon: "☕" },
        { name: "C++ (DSA)", icon: "➕" },
      ],
    },
    {
      title: "Concepts",
      color: "#a78bfa",
      skills: [
        { name: "OOP", icon: "📦" },
        { name: "MVC", icon: "🏗️" },
        { name: "DAO", icon: "🗃️" },
        { name: "REST APIs", icon: "🔁" },
        { name: "Microservices", icon: "🧩" },
        { name: "SDLC", icon: "🔄" },
      ],
    },
    {
      title: "Tools & Platforms",
      color: "#fb923c",
      skills: [
        { name: "GitHub", icon: "🐙" },
        { name: "VS Code", icon: "💙" },
        { name: "Tomcat", icon: "🐱" },
        { name: "Ollama", icon: "🦙" },
        { name: "HuggingFace", icon: "🤗" },
        { name: "Postman", icon: "📮" },
      ],
    },
  ],

  experience: [
    {
      role: "Full Stack Development Intern",
      company: "Cognifyz Technologies",
      period: "01/2026 – 02/2026",
      points: [
        "Developed and maintained web application features using full stack technologies (frontend & backend).",
        "Collaborated with team members to design, implement, and optimize application functionality.",
        "Improved code quality and performance through debugging and problem-solving.",
      ],
    },
  ],

  projects: [
    {
      title: "RAGCompDoc",
      desc: "RAG API built with FastAPI, LangChain, ChromaDB, HuggingFace embeddings (all-MiniLM-L6-v2), and Ollama (llama3). Lets users upload PDFs and chat with them intelligently. Features streaming responses, session memory, and a React + Vite frontend. 100% local — no OpenAI, no paid APIs.",
      stack: ["FastAPI", "LangChain", "ChromaDB", "Python", "React", "Ollama", "HuggingFace"],
      link: "https://github.com/sp1130?tab=projects",
      badge: "AI / LLM",
    },
    {
      title: "Task-Mate React App",
      desc: "Task management application developed using React and Tailwind CSS with a clean, responsive interface.",
      stack: ["React", "Tailwind CSS"],
      link: "https://github.com/sp1130?tab=projects",
    },
    {
      title: "Rafting Booking Website",
      desc: "Real-world website for rafting bookings with a fully functional booking flow, responsive design, and live deployment.",
      stack: ["HTML", "CSS", "JavaScript"],
      link: "https://github.com/sp1130?tab=projects",
      live: "https://spiffy-sunshine-9a8967.netlify.app/",
    },
    {
      title: "HR Management System",
      desc: "Web application using JSP & Java JDBC for MySQL connectivity. Implements DAO pattern and Getter-Setter methods for clean data transfer between frontend and database.",
      stack: ["Java", "JSP", "MySQL", "HTML", "Bootstrap"],
      link: "https://github.com/sp1130?tab=projects",
    },
    {
      title: "Cab Booking Website",
      desc: "Full-stack cab booking platform with React frontend, Node.js backend, Bootstrap UI, and MySQL database integration.",
      stack: ["React", "Node.js", "MySQL", "Bootstrap"],
      link: "https://github.com/sp1130?tab=projects",
    },
    {
      title: "Portfolio Website",
      desc: "Personal portfolio website built with Bootstrap — single-page with smooth navigation to all sections.",
      stack: ["HTML", "CSS", "Bootstrap"],
      link: "https://github.com/sp1130?tab=projects",
      live: "https://spiffy-sunshine-9a8967.netlify.app/",
    },
  ],

  education: [
    {
      degree: "Master of Computer Applications (MCA) — AIML",
      institute: "CSMU College, Panvel, Raigad",
      year: "Present",
    },
    {
      degree: "MERN Stack Developer (Certification)",
      institute: "Apana College (Online)",
      year: "Present",
    },
    {
      degree: "Diploma in Full-Stack Java",
      institute: "IIHT Institute, Kharghar – Sector 7",
      year: "2025",
    },
    {
      degree: "BSc in Computer Science",
      institute: "Anandibai Pradhan College of Science, Nagothane – Raigad",
      year: "2025",
    },
  ],

  certificates: ["Full Stack Development Intern | Cognifyz Technologies"],
};

/* ─────────────────────────────────────────
   UTILITIES
───────────────────────────────────────── */
function useInView(threshold = 0.1) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, visible];
}

function Reveal({ children, delay = 0, style = {} }) {
  const [ref, visible] = useInView();
  return (
    <div
      ref={ref}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(28px)",
        transition: `opacity 0.7s ${delay}s ease, transform 0.7s ${delay}s ease`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

/* ─────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────── */
export default function Portfolio() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);

  /* inject global CSS */
  useEffect(() => {
    const el = document.createElement("style");
    el.id = "sp-global";
    el.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Playfair+Display:ital,wght@0,700;1,700&display=swap');
      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
      html { scroll-behavior: smooth; font-size: 16px; }
      body { font-family: 'Inter', system-ui, sans-serif; background: #0e0e0e; color: #e2e2e2; line-height: 1.7; -webkit-font-smoothing: antialiased; }
      ::-webkit-scrollbar { width: 4px; }
      ::-webkit-scrollbar-track { background: #0e0e0e; }
      ::-webkit-scrollbar-thumb { background: #38bdf8; border-radius: 4px; }
      a { text-decoration: none; }
      @keyframes fadeUp   { from { opacity:0; transform:translateY(30px); } to { opacity:1; transform:translateY(0); } }
      @keyframes pulse    { 0%,100%{opacity:1} 50%{opacity:0.35} }
      @keyframes spin     { to { transform: rotate(360deg); } }

      /* NAV */
      .sp-nav { position:fixed; top:0; left:0; right:0; z-index:200; display:flex; justify-content:space-between; align-items:center; padding:0 5%; height:62px; background:rgba(14,14,14,0.92); backdrop-filter:blur(16px); border-bottom:1px solid #1f1f1f; }
      .sp-logo { font-family:'Playfair Display',serif; font-size:1.4rem; font-weight:700; color:#38bdf8; letter-spacing:2px; }
      .sp-nav-links { display:flex; gap:1.75rem; list-style:none; }
      .sp-nav-links a { font-size:0.75rem; font-weight:600; color:#888; letter-spacing:0.09em; text-transform:uppercase; transition:color 0.2s; }
      .sp-nav-links a:hover { color:#38bdf8; }
      .sp-hamburger { display:none; background:none; border:1px solid #2a2a2a; border-radius:4px; padding:7px 10px; cursor:pointer; color:#aaa; font-size:1.1rem; line-height:1; }
      .sp-mob-menu { display:none; flex-direction:column; position:absolute; top:62px; left:0; right:0; background:#111; border-bottom:1px solid #1f1f1f; padding:1.25rem 5%; gap:1.1rem; list-style:none; z-index:199; }
      .sp-mob-menu.open { display:flex; }
      .sp-mob-menu a { font-size:0.85rem; font-weight:600; color:#888; letter-spacing:0.07em; text-transform:uppercase; }

      /* SECTION */
      .sp-section { padding:6rem 5%; }
      .sp-section-white { padding:6rem 5%; background:#141414; }
      .sp-inner { max-width:1100px; margin:0 auto; }
      .sp-section-hdr { display:flex; align-items:baseline; gap:1.25rem; margin-bottom:3rem; }
      .sp-section-num { font-family:'Playfair Display',serif; font-size:0.9rem; color:#555; font-style:italic; }
      .sp-section-title { font-family:'Playfair Display',serif; font-size:clamp(1.8rem,3vw,2.5rem); letter-spacing:-0.02em; line-height:1.1; color:#f0f0f0; }
      .sp-section-line { flex:1; height:1px; background:#1f1f1f; }

      /* HERO */
      .sp-hero { min-height:100vh; display:flex; align-items:center; padding:8rem 5% 5rem; background:radial-gradient(ellipse at 70% 50%, #0d2035 0%, #0e0e0e 60%); }
      .sp-hero-grid { display:grid; grid-template-columns:1.2fr 1fr; gap:4rem; align-items:center; max-width:1100px; width:100%; margin:0 auto; }
      .sp-hero-anim { animation:fadeUp 0.85s ease both; }
      .sp-hero-anim-d { animation:fadeUp 0.85s 0.25s ease both; }
      .sp-eyebrow { font-size:0.72rem; font-weight:700; letter-spacing:0.14em; text-transform:uppercase; color:#38bdf8; margin-bottom:1rem; display:flex; align-items:center; gap:10px; }
      .sp-eyebrow::before { content:''; display:block; width:28px; height:1.5px; background:#38bdf8; }
      .sp-hero-name { font-family:'Playfair Display',serif; font-size:clamp(3rem,6vw,5.2rem); line-height:1.05; letter-spacing:-0.02em; margin-bottom:1.5rem; color:#f0f0f0; }
      .sp-hero-name em { font-style:italic; color:#38bdf8; }
      .sp-hero-desc { font-size:0.95rem; color:#888; line-height:1.9; max-width:430px; margin-bottom:2.5rem; font-weight:300; }
      .sp-cta { display:flex; gap:0.9rem; flex-wrap:wrap; }

      /* BUTTONS */
      .sp-btn { display:inline-flex; align-items:center; gap:6px; padding:0.78rem 1.6rem; font-size:0.8rem; font-weight:700; font-family:'Inter',sans-serif; letter-spacing:0.05em; border-radius:3px; border:none; cursor:pointer; transition:all 0.2s; }
      .sp-btn-primary { background:#38bdf8; color:#0e0e0e; }
      .sp-btn-primary:hover { background:#0ea5e9; }
      .sp-btn-ghost { background:transparent; color:#ccc; border:1px solid #333; }
      .sp-btn-ghost:hover { border-color:#38bdf8; color:#38bdf8; }
      .sp-btn-green { background:#2a5c45; color:#fff; }
      .sp-btn-green:hover { background:#1e4433; }

      /* AVATAR CARD */
      .sp-avatar-card { background:#141414; border:1px solid #1f1f1f; border-radius:6px; padding:2.5rem; text-align:center; width:260px; }
      .sp-avatar-circle { width:90px; height:90px; border-radius:50%; background:#0d1f2d; border:2px solid #38bdf8; display:flex; align-items:center; justify-content:center; font-family:'Playfair Display',serif; font-size:2rem; color:#38bdf8; margin:0 auto 1.25rem; }
      .sp-avatar-name { font-family:'Playfair Display',serif; font-size:1.25rem; color:#f0f0f0; margin-bottom:4px; }
      .sp-avatar-role { font-size:0.7rem; color:#555; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; margin-bottom:1.25rem; }
      .sp-status { display:inline-flex; align-items:center; gap:7px; font-size:0.73rem; color:#38bdf8; font-weight:600; background:#0d1f2d; padding:5px 14px; border-radius:999px; }
      .sp-status-dot { width:7px; height:7px; background:#38bdf8; border-radius:50%; animation:pulse 2s infinite; flex-shrink:0; }

      /* ABOUT */
      .sp-about-grid { display:grid; grid-template-columns:1.3fr 1fr; gap:5rem; align-items:start; }
      .sp-fact-row { padding-bottom:1rem; border-bottom:1px solid #1f1f1f; margin-bottom:0; }
      .sp-fact-label { font-size:0.66rem; font-weight:700; letter-spacing:0.12em; text-transform:uppercase; color:#555; margin-bottom:3px; }
      .sp-fact-value { font-size:0.9rem; color:#ccc; font-weight:500; }

      /* SKILLS */
      .sp-skill-cat { margin-bottom:2.25rem; }
      .sp-skill-cat-title { font-size:0.68rem; font-weight:700; letter-spacing:0.15em; text-transform:uppercase; margin-bottom:1rem; display:flex; align-items:center; gap:10px; }
      .sp-skill-cat-line { flex:1; height:1px; background:#1f1f1f; }
      .sp-skill-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:10px; }
      .sp-skill-card { background:#1a1a1a; border:1px solid #252525; border-radius:8px; padding:1.1rem 0.6rem; text-align:center; transition:border-color 0.2s, transform 0.2s; }
      .sp-skill-card:hover { transform:translateY(-3px); }
      .sp-skill-icon { font-size:1.9rem; margin-bottom:7px; display:block; line-height:1; }
      .sp-skill-name { font-size:0.67rem; font-weight:600; color:#888; letter-spacing:0.04em; }

      /* EXPERIENCE */
      .sp-exp-card { background:#141414; border:1px solid #1f1f1f; border-left:3px solid #38bdf8; border-radius:4px; padding:2rem 2.5rem; margin-bottom:1.5rem; }
      .sp-exp-role { font-family:'Playfair Display',serif; font-size:1.5rem; color:#f0f0f0; margin-bottom:4px; }
      .sp-exp-meta { font-size:0.74rem; font-weight:700; color:#38bdf8; letter-spacing:0.06em; text-transform:uppercase; margin-bottom:1.25rem; }
      .sp-exp-point { font-size:0.88rem; color:#888; line-height:1.85; font-weight:300; margin-bottom:5px; display:flex; gap:10px; }
      .sp-exp-arrow { color:#38bdf8; flex-shrink:0; }

      /* PROJECTS */
      .sp-proj-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(310px,1fr)); gap:2px; background:#1f1f1f; border:1px solid #1f1f1f; }
      .sp-proj-card { background:#141414; padding:2.2rem; transition:background 0.2s; position:relative; overflow:hidden; }
      .sp-proj-card::after { content:''; position:absolute; bottom:0; left:0; right:0; height:2px; background:#38bdf8; transform:scaleX(0); transition:transform 0.3s; transform-origin:left; }
      .sp-proj-card:hover { background:#181818; }
      .sp-proj-card:hover::after { transform:scaleX(1); }
      .sp-proj-num { font-family:'Playfair Display',serif; font-size:2.2rem; color:#252525; font-style:italic; line-height:1; margin-bottom:0.75rem; }
      .sp-proj-title { font-family:'Playfair Display',serif; font-size:1.25rem; color:#f0f0f0; margin-bottom:0.6rem; line-height:1.2; }
      .sp-proj-desc { font-size:0.82rem; color:#777; line-height:1.82; font-weight:300; margin-bottom:1rem; }
      .sp-proj-stack { display:flex; flex-wrap:wrap; gap:5px; margin-bottom:1rem; }
      .sp-proj-tech { font-size:0.63rem; font-weight:700; letter-spacing:0.07em; text-transform:uppercase; color:#38bdf8; background:#0d1f2d; padding:3px 9px; border-radius:2px; }
      .sp-proj-links { display:flex; gap:1.25rem; flex-wrap:wrap; }
      .sp-proj-link { font-size:0.76rem; font-weight:700; color:#aaa; letter-spacing:0.05em; display:inline-flex; align-items:center; gap:4px; transition:color 0.15s; }
      .sp-proj-link:hover { color:#38bdf8; }
      .sp-proj-badge { font-size:0.6rem; font-weight:700; letter-spacing:0.09em; text-transform:uppercase; background:#0d2d1a; color:#4ade80; padding:3px 10px; border-radius:2px; }

      /* EDUCATION */
      .sp-edu-wrap { border:1px solid #1f1f1f; }
      .sp-edu-row { display:grid; grid-template-columns:1fr auto; align-items:center; padding:1.4rem 2rem; border-bottom:1px solid #1f1f1f; background:#141414; }
      .sp-edu-row:last-child { border-bottom:none; }
      .sp-edu-degree { font-family:'Playfair Display',serif; font-size:1.1rem; color:#e8e8e8; margin-bottom:3px; }
      .sp-edu-inst { font-size:0.8rem; color:#666; }
      .sp-edu-year { font-family:'Playfair Display',serif; font-style:italic; font-size:0.95rem; color:#38bdf8; white-space:nowrap; padding-left:1rem; }

      /* CONTACT */
      .sp-contact-grid { display:grid; grid-template-columns:1fr 1fr; gap:5rem; align-items:start; }
      .sp-contact-intro { font-family:'Playfair Display',serif; font-size:clamp(1.4rem,2.5vw,1.9rem); font-style:italic; line-height:1.45; color:#aaa; margin-bottom:2rem; }
      .sp-contact-link { display:flex; align-items:center; gap:12px; color:#888; font-size:0.86rem; font-weight:400; padding-bottom:1rem; border-bottom:1px solid #1f1f1f; margin-bottom:1rem; transition:color 0.2s; }
      .sp-contact-link:hover { color:#f0f0f0; }
      .sp-contact-icon { width:36px; height:36px; background:#1a1a1a; border:1px solid #252525; border-radius:3px; display:flex; align-items:center; justify-content:center; flex-shrink:0; transition:background 0.2s; }
      .sp-contact-link:hover .sp-contact-icon { background:#0d1f2d; border-color:#38bdf8; }
      .sp-form-label { font-size:0.65rem; font-weight:700; letter-spacing:0.12em; text-transform:uppercase; color:#555; margin-bottom:7px; display:block; }
      .sp-form-input { width:100%; background:#141414; border:1px solid #252525; border-radius:3px; padding:0.78rem 1rem; font-size:0.88rem; font-family:'Inter',sans-serif; color:#e2e2e2; outline:none; transition:border-color 0.2s; margin-bottom:1rem; }
      .sp-form-input:focus { border-color:#38bdf8; }
      .sp-form-input::placeholder { color:#333; }

      /* FOOTER */
      .sp-footer { background:#090909; color:#333; text-align:center; padding:1.75rem; font-size:0.76rem; border-top:1px solid #1a1a1a; }
      .sp-footer a { color:#555; }
      .sp-footer a:hover { color:#38bdf8; }

      /* RESPONSIVE */
      @media (max-width:900px) {
        .sp-hero-grid { grid-template-columns:1fr !important; }
        .sp-about-grid { grid-template-columns:1fr !important; gap:2.5rem !important; }
        .sp-contact-grid { grid-template-columns:1fr !important; gap:2.5rem !important; }
        .sp-avatar-card-wrap { display:none !important; }
      }
      @media (max-width:768px) {
        .sp-nav-links { display:none !important; }
        .sp-hamburger { display:block !important; }
        .sp-skill-grid { grid-template-columns:repeat(3,1fr) !important; }
        .sp-section, .sp-section-white { padding:4rem 4% !important; }
        .sp-proj-grid { grid-template-columns:1fr !important; }
      }
      @media (max-width:480px) {
        .sp-skill-grid { grid-template-columns:repeat(2,1fr) !important; }
        .sp-edu-row { grid-template-columns:1fr !important; gap:4px !important; }
        .sp-edu-year { padding-left:0 !important; }
        .sp-cta { flex-direction:column; }
        .sp-btn { justify-content:center; }
      }
    `;
    if (!document.getElementById("sp-global")) document.head.appendChild(el);
    return () => { const e = document.getElementById("sp-global"); if (e) e.remove(); };
  }, []);

  const navItems = ["About", "Skills", "Experience", "Projects", "Education", "Contact"];

  /* SVG ICONS */
  const IconGithub = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
    </svg>
  );
  const IconLinkedIn = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
      <rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" />
    </svg>
  );
  const IconMail = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  );
  const IconPhone = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.63 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.83a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z" />
    </svg>
  );
  const IconExternal = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  );
  const IconDown = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );

  return (
    <div>
      {/* ── NAV ─────────────────────────────── */}
      <nav className="sp-nav">
        <span className="sp-logo">SP</span>
        <ul className="sp-nav-links">
          {navItems.map((n) => (
            <li key={n}><a href={`#${n.toLowerCase()}`}>{n}</a></li>
          ))}
        </ul>
        <button className="sp-hamburger" aria-label="menu" onClick={() => setMenuOpen((o) => !o)}>
          {menuOpen ? "✕" : "☰"}
        </button>
        <ul className={`sp-mob-menu${menuOpen ? " open" : ""}`}>
          {navItems.map((n) => (
            <li key={n}><a href={`#${n.toLowerCase()}`} onClick={() => setMenuOpen(false)}>{n}</a></li>
          ))}
        </ul>
      </nav>

      {/* ── HERO ────────────────────────────── */}
      <section id="hero" className="sp-hero">
        <div className="sp-hero-grid">
          <div className="sp-hero-anim">
            <p className="sp-eyebrow">Full Stack Developer</p>
            <h1 className="sp-hero-name">
              Soham<br /><em>Patne</em>
            </h1>
            <p className="sp-hero-desc">{DATA.profile}</p>
            <div className="sp-cta">
              <a href="#projects" className="sp-btn sp-btn-primary">View Projects</a>
              <a href="#contact" className="sp-btn sp-btn-ghost">Get in Touch</a>
              <a
                href={DATA.resume}
                download="Soham_Patne.pdf"
                className="sp-btn sp-btn-ghost"
              >
                <IconDown /> Download Resume
              </a>
            </div>
          </div>

          <div className="sp-hero-anim-d sp-avatar-card-wrap" style={{ display: "flex", justifyContent: "center" }}>
            <div className="sp-avatar-card">
              <div className="sp-avatar-circle">SP</div>
              <p className="sp-avatar-name">Soham Patne</p>
              <p className="sp-avatar-role">Java · MERN · AI/ML</p>
              <span className="sp-status">
                <span className="sp-status-dot" /> Open to opportunities
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ── ABOUT ───────────────────────────── */}
      <section id="about" className="sp-section-white">
        <div className="sp-inner">
          <div className="sp-section-hdr">
            <span className="sp-section-num">01</span>
            <h2 className="sp-section-title">About me</h2>
            <div className="sp-section-line" />
          </div>
          <Reveal>
            <div className="sp-about-grid">
              <div>
                <p style={{ color: "#888", fontSize: "1rem", lineHeight: 1.9, fontWeight: 300, marginBottom: "1.3rem" }}>
                  I'm a <strong style={{ color: "#e2e2e2", fontWeight: 600 }}>Full-Stack Java Developer</strong> with a BSc in Computer Science, currently pursuing <strong style={{ color: "#e2e2e2", fontWeight: 600 }}>MCA in AIML</strong> at CSMU College, Panvel.
                </p>
                <p style={{ color: "#888", fontSize: "1rem", lineHeight: 1.9, fontWeight: 300, marginBottom: "1.3rem" }}>
                  My stack covers <strong style={{ color: "#e2e2e2", fontWeight: 600 }}>Java, Spring Boot, J2EE, React, Node.js</strong> and databases like <strong style={{ color: "#e2e2e2", fontWeight: 600 }}>MySQL, MongoDB, ChromaDB</strong>. I recently built <strong style={{ color: "#38bdf8" }}>RAGCompDoc</strong> — a fully local RAG chatbot using FastAPI + LangChain + Ollama.
                </p>
                <p style={{ color: "#888", fontSize: "1rem", lineHeight: 1.9, fontWeight: 300, marginBottom: "2rem" }}>
                  Interned at <strong style={{ color: "#e2e2e2", fontWeight: 600 }}>Cognifyz Technologies</strong> as a Full Stack Developer. Certified in Full-Stack Java (IIHT) and currently completing MERN Stack certification at Apana College.
                </p>
               <a
  href="/assets/Soham_Patne.pdf"
  target="_blank"
  rel="noopener noreferrer"
>
  View Resume
</a>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                {[
                  ["Email", DATA.email],
                  ["Phone", DATA.phone],
                  ["Location", DATA.location],
                  ["GitHub", "github.com/sp1130"],
                  ["Status", "Open to opportunities"],
                ].map(([label, value]) => (
                  <div key={label} className="sp-fact-row">
                    <div className="sp-fact-label">{label}</div>
                    <div className="sp-fact-value" style={{ color: label === "Status" ? "#4ade80" : "#ccc" }}>{value}</div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ── SKILLS ──────────────────────────── */}
      <section id="skills" className="sp-section">
        <div className="sp-inner">
          <div className="sp-section-hdr">
            <span className="sp-section-num">02</span>
            <h2 className="sp-section-title">What I have learnt so far . . .</h2>
            <div className="sp-section-line" />
          </div>
          <Reveal>
            {DATA.skillCategories.map((cat) => (
              <div key={cat.title} className="sp-skill-cat">
                <p className="sp-skill-cat-title" style={{ color: cat.color }}>
                  {cat.title}
                  <span className="sp-skill-cat-line" />
                </p>
                <div className="sp-skill-grid">
                  {cat.skills.map((sk) => (
                    <div
                      key={sk.name}
                      className="sp-skill-card"
                      style={{ "--hover-color": cat.color }}
                      onMouseEnter={(e) => (e.currentTarget.style.borderColor = cat.color)}
                      onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#252525")}
                    >
                      <span className="sp-skill-icon">{sk.icon}</span>
                      <span className="sp-skill-name">{sk.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </Reveal>
        </div>
      </section>

      {/* ── EXPERIENCE ──────────────────────── */}
      <section id="experience" className="sp-section-white">
        <div className="sp-inner">
          <div className="sp-section-hdr">
            <span className="sp-section-num">03</span>
            <h2 className="sp-section-title">Experience</h2>
            <div className="sp-section-line" />
          </div>
          {DATA.experience.map((exp, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="sp-exp-card">
                <h3 className="sp-exp-role">{exp.role}</h3>
                <p className="sp-exp-meta">{exp.company}&nbsp;·&nbsp;{exp.period}</p>
                <ul style={{ listStyle: "none" }}>
                  {exp.points.map((pt, j) => (
                    <li key={j} className="sp-exp-point">
                      <span className="sp-exp-arrow">→</span>
                      {pt}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* ── PROJECTS ────────────────────────── */}
      <section id="projects" className="sp-section">
        <div className="sp-inner">
          <div className="sp-section-hdr">
            <span className="sp-section-num">04</span>
            <h2 className="sp-section-title">Projects</h2>
            <div className="sp-section-line" />
          </div>
          <Reveal>
            <div className="sp-proj-grid">
              {DATA.projects.map((p, i) => (
                <div key={i} className="sp-proj-card">
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "0.6rem" }}>
                    <div className="sp-proj-num">0{i + 1}</div>
                    {p.badge && <span className="sp-proj-badge">{p.badge}</span>}
                  </div>
                  <h3 className="sp-proj-title">{p.title}</h3>
                  <p className="sp-proj-desc">{p.desc}</p>
                  <div className="sp-proj-stack">
                    {p.stack.map((t) => (
                      <span key={t} className="sp-proj-tech">{t}</span>
                    ))}
                  </div>
                  <div className="sp-proj-links">
                    <a href={p.link} target="_blank" rel="noopener noreferrer" className="sp-proj-link">
                      <IconGithub /> Code
                    </a>
                    {p.live && (
                      <a href={p.live} target="_blank" rel="noopener noreferrer" className="sp-proj-link">
                        <IconExternal /> Live Demo
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* ── EDUCATION ───────────────────────── */}
      <section id="education" className="sp-section-white">
        <div className="sp-inner">
          <div className="sp-section-hdr">
            <span className="sp-section-num">05</span>
            <h2 className="sp-section-title">Education</h2>
            <div className="sp-section-line" />
          </div>
          <Reveal>
            <div className="sp-edu-wrap">
              {DATA.education.map((e, i) => (
                <div key={i} className="sp-edu-row">
                  <div>
                    <div className="sp-edu-degree">{e.degree}</div>
                    <div className="sp-edu-inst">{e.institute}</div>
                  </div>
                  <div className="sp-edu-year">{e.year}</div>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div style={{ marginTop: "2rem" }}>
              <p style={{ fontSize: "0.66rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#38bdf8", marginBottom: "1rem" }}>Certificates</p>
              {DATA.certificates.map((c, i) => (
                <div key={i} style={{ background: "#141414", border: "1px solid #1f1f1f", borderLeft: "3px solid #38bdf8", borderRadius: 3, padding: "0.9rem 1.5rem", fontSize: "0.88rem", color: "#ccc", fontWeight: 400 }}>
                  🏅 {c}
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* ── CONTACT ─────────────────────────── */}
      <section id="contact" className="sp-section">
        <div className="sp-inner">
          <div className="sp-section-hdr">
            <span className="sp-section-num">06</span>
            <h2 className="sp-section-title">Get in Touch . . .</h2>
            <div className="sp-section-line" />
          </div>
          <Reveal>
            <div className="sp-contact-grid">
              {/* LEFT */}
              <div>
                <p className="sp-contact-intro">Have a project in mind? Let's build something together.</p>

                <a href={`mailto:${DATA.email}`} className="sp-contact-link">
                  <span className="sp-contact-icon"><IconMail /></span>
                  {DATA.email}
                </a>
                <a href={`tel:${DATA.phone}`} className="sp-contact-link">
                  <span className="sp-contact-icon"><IconPhone /></span>
                  {DATA.phone}
                </a>
                <a href={DATA.linkedin} target="_blank" rel="noopener noreferrer" className="sp-contact-link">
                  <span className="sp-contact-icon"><IconLinkedIn /></span>
                  LinkedIn — Soham Patne
                </a>
                <a href={DATA.github} target="_blank" rel="noopener noreferrer" className="sp-contact-link">
                  <span className="sp-contact-icon"><IconGithub /></span>
                  GitHub — sp1130
                </a>
                <a href={DATA.resume} download="Sohampatne.pdf" className="sp-contact-link">
                  <span className="sp-contact-icon"><IconDown /></span>
                  Download Resume (PDF)
                </a>
              </div>

              {/* RIGHT – form */}
              <div>
                {sent ? (
                  <div style={{ fontFamily: "'Playfair Display',serif", fontSize: "1.6rem", fontStyle: "italic", color: "#38bdf8", lineHeight: 1.5 }}>
                    Message sent!<br />I'll get back to you soon ✦
                  </div>
                ) : (
                  <>
                    {[
                      { label: "Your Name", key: "name", type: "text", placeholder: "Jane Smith" },
                      { label: "Email Address", key: "email", type: "email", placeholder: "jane@example.com" },
                    ].map((f) => (
                      <div key={f.key}>
                        <label className="sp-form-label">{f.label}</label>
                        <input
                          type={f.type}
                          placeholder={f.placeholder}
                          className="sp-form-input"
                          value={form[f.key]}
                          onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                        />
                      </div>
                    ))}
                    <label className="sp-form-label">Message</label>
                    <textarea
                      placeholder="Hi Soham, I'd love to work with you on..."
                      className="sp-form-input"
                      style={{ minHeight: 130, resize: "vertical" }}
                      value={form.message}
                      onChange={(e) => setForm({ ...form, message: e.target.value })}
                    />
                    <button
                      className="sp-btn sp-btn-primary"
                      style={{ marginTop: "0.5rem" }}
                      onClick={() => { if (form.name && form.email) setSent(true); }}
                    >
                      Send Message →
                    </button>
                  </>
                )}
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ── FOOTER ──────────────────────────── */}
      <footer className="sp-footer">
        © 2026 Soham Patne · Full Stack Developer &nbsp;·&nbsp;
        <a href={DATA.github} target="_blank" rel="noopener noreferrer">GitHub</a>
        &nbsp;·&nbsp;
        <a href={DATA.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a>
        &nbsp;·&nbsp;
        <a href={DATA.resume} download="Sohampatne.pdf">Resume</a>
      </footer>
    </div>
  );
}
